<template>
  <div class="align date-picker">
    <div class="mode-select align">
      <div
        v-for="(item, index) in list"
        :key="index"
        @click="modeToggle(item, index)"
        class="mode-item"
        :class="index === modeDefault ? 'mode-active' : ''"
      >{{ item.label }}</div>
      
    </div>
    <div class="mode-select date-select">
      <van-dropdown-menu active-color="#2877FF">
        <van-dropdown-item title-class="custorm" @change="change" v-model="dropdownValue" :options="dropdownOption" />
      </van-dropdown-menu>
    </div>
    <button v-show="$route.name === 'carrierListLive' && $store.state.userLevel" class="share-btn" @click="goShare">
      <img class="icon" src="https://s6.bihukankan.com/img/1112share.png" alt="icon" />
      分享
    </button>
    <van-icon v-show="['carrierListBrand', 'shopRanking'].includes($route.name)" name="search" class="search-icon" @click="goSearch" />
  </div>
</template>

<script>
import moment from 'moment';

let list = [
  {
    label: '日榜',
    value: '1',
    length: 7,
    mode: 'days'
  },
  {
    label: '周榜',
    value: '7',
    length: 5,
    mode: 'isoWeek'
  },
  {
    label: '月榜',
    value: '30',
    length: 3,
    mode: 'month'
  },
]
let list2 = [
  {
    label: '日榜',
    value: '1',
    length: 7,
    mode: 'days'
  },
]
export default {
  props: {
    defaultOpenVipModalStatus: {
      type: Object,
      default: () => {
        return { status: true, textChange: 'carrierList' };
      }
    },
    vipVersion: Number
  },
  data() {
    return {
      modeDefault: 0,
      list: this.$route.path === '/carrierList/liveSelf' ? list2 : list,
      dropdownValue: 0,
      dropdownOption: this.dropdownDay(list[0].length, list[0].mode),
      canShare: false
    };
  },
  computed: {
    time() {
      const text = this.dropdownOption[this.dropdownValue].emit;
      return JSON.parse(text.match(/\[(.+?)\]/g)[0])
    },
  },
  mounted() {
    const today = moment().startOf('day').unix()
    this.shareSwitch([today - 86400, today])
    this.loadAgain()
  },
  watch: {
    time(val) {
      this.shareSwitch(val)
    }
  },
  methods: {
    // 分享二维码开关
    shareSwitch([start, end]) {
      if (!this.$store.state.userLevel || this.$route.name !== 'carrierListLive') {
        return
      }
      const params = { mode: 'DATE', date: null }
      // 日榜
      if (end - start < 3 * 86400) {
        params.date = moment(start * 1000).format('YYYYMMDD')
      }
      // 周榜
      else if (end - start < 10 * 86400) {
        params.mode = 'WEEKLY'
        params.date = moment(start * 1000).format('YYYYWW')
      }
      // 月榜
      else if (end - start > 10 * 86400) {
        params.mode = 'MONTHLY'
        params.date = moment(start * 1000).format('YYYYMM')
      }
      this.$get({
        road: 'shareSwitch',
        version: 'v2',
        params
      }).then(res => {
        this.canShare = res.enable
      })
    },
    goShare() {
      if (this.canShare) {
        this.$router.push({
          path: '/share/live',
          query: { time: this.time }
        })
      } else {
        this.$message.warning('榜单数据审核中,可选择其他时间段')
      }
    },
    modeToggle(val, index) {
      // 切换日周月选择
      // 切换的时候需要把下拉框改到第一个

      // 如果传递下来vip等级  说明需要vip权限 在这先判断权限之后在放行
      if (this.vipVersion) {
        if (this.$store.state.userLevel && (this.$store.state.userLevel <= this.vipVersion)) {
          this.modeToggleSuccess(val, index);
        } else {
          this.$store.commit('WRITEOVERLAYSHOW', this.defaultOpenVipModalStatus);
        }
      } else {
        this.modeToggleSuccess(val, index);
      }
    },
    modeToggleSuccess(val, index) {
      this.modeDefault = index;
      this.dropdownValue = 0;
      if (index === 0) {
        this.dropdownOption = this.dropdownDay(list[index].length, list[index].mode);
      } else if (index === 1) {
        this.dropdownOption = this.dropdownWeek(list[index].length, list[index].mode);
      } else if (index === 2) {
        this.dropdownOption = this.dropdownMonth(list[index].length, list[index].mode);
      }
      this.loadAgain();
    },
    change(val) {
      if (this.$store.state.userLevel && this.$store.state.userLevel <= 100) {
        this.loadAgain();
      } else {
        setTimeout(() => {
          this.$store.commit('WRITEOVERLAYSHOW', this.defaultOpenVipModalStatus);
        }, 500);
      }
    },
    loadAgain() {
      this.$emit('loadAgain', this.dropdownOption[this.dropdownValue]);
    },
    dropdownDay(length, mode) {
      const now_new = new moment()
      const now = new moment();
      let before6 = 0
      // 6点前不显示昨天选项
      if (now.hours() < 6) {
        now.subtract(1, 'days');
        now_new.subtract(1, 'days');
        before6 = 1
      }
      return [...new Array(length)].map((ele, index) => {
        return {
          text: now.subtract(1, 'days').format('MM-DD'),
          newtext: now_new.subtract(1, 'days').format('YYYYMMDD'),
          value: index,
          emit: this.returnEmit(index + before6, mode),
          timeMode: 14
        };
      });
    },
    dropdownWeek(length, mode) {
      return [...new Array(length)].map((ele, index) => {
        return {
          text: `${moment().subtract(index + 1, mode).startOf(mode).format('MM/DD')} - ${moment().subtract(index + 1, mode).endOf(mode).format('MM/DD')}`,
          newtext: `${moment().subtract(index + 1, mode).endOf(mode).format('YYYYMMDD')}`,
          value: index,
          emit: this.returnEmit(index, mode),
          timeMode: 13
        };
      });
    },
    dropdownMonth(length, mode) {
      return [...new Array(length)].map((ele, index) => {
        return {
          text: `${moment().subtract(index + 1, mode).startOf(mode).format('YYYY-MM')}`,
          newtext:`${moment().subtract(index + 1, mode).endOf(mode).format('YYYYMMDD')}`,
          value: index,
          emit: this.returnEmit(index, mode),
          timeMode: 12
        };
      });
    },
    returnEmit(index, mode) {
      return `$between: [${moment().subtract(index + 1, mode).startOf(mode).unix()}, ${moment().subtract(index + 1, mode).endOf(mode).unix()}]`;
    },
    goSearch() {
      const obj = {
        carrierListBrand: 'brand',
        shopRanking: 'shop'
      }
      this.$router.push({ path: '/search?tab=' + obj[this.$route.name] })
    }
  }
};
</script>

<style lang="less" scoped>
.date-picker {
  width: 7.5rem;
  height: 0.8rem;
  background: #fff;
  padding-right: 0.3rem;

  .mode-select {
    height: 0.8rem;
    .mode-item {
      width: 1rem;
      text-align: center;
      color: #4a4a4a;
      font-size: 0.28rem;
      line-height: 0.8rem;
    }

    .mode-active {
      color: #2a89f4;
    }
  }

  .date-select {
    margin-left: auto;
  }

  .share-btn {
    margin-left: 0.25rem;
    height: 0.5rem;
    background: #ffffff;
    color: #2a89f4;
    border: 1px solid #2a89f4;
    font-size: 0.28rem;
    border-radius: 0.08rem;

    .icon {
      width: 0.28rem;
      height: 0.28rem;
      vertical-align: top;
    }
  }

  .search-icon {
    font-size: 0.4rem;
    line-height: 0.8rem;
    color: #4a4a4a;
    margin-left: 0.5rem;
  }
}
</style>

<style lang="less">
.date-picker {
  .van-dropdown-menu__bar{
    box-shadow: none!important;
    background: none!important;
  }
  .van-dropdown-menu {
    height: 0.8rem;

    .van-dropdown-item {
      z-index: 1;
    }
  }
}
</style>